import React, { createContext, useEffect, useState } from 'react'
import { SchoolsService } from 'services/schools'

const PanelContext = createContext({})

export const PanelProvider = ({ children }) => {
  const [ year, setYear ] = useState(new Date().getFullYear())
  const [ semester, setSemester ] = useState(new Date().getMonth() < 6 ? 1 : 2)
  const [ years, setYears ] = useState([])

  useEffect(() => {
    SchoolsService.getYears().then(({ data }) => setYears(data.map(item => {
      return {
        value: `${item.Ano}.${item.Semestre}`,
        label: `SiSU ${item.Ano} - ${item.Semestre}º. Sem.`,
      }
    }).sort().reverse()))
  }, [])

  return (
    <PanelContext.Provider
      value={{
        year,
        setYear,
        semester,
        setSemester,
        years,
      }}
    >
      {children}
    </PanelContext.Provider>
  )
}

export default PanelContext
